import { Day } from '../../../helpers/Day';
import { IGymTimeSlotsRepository } from '../interfaces/igymtimeslots-repository';

export class CachedGymTimeSlotsRepository implements IGymTimeSlotsRepository {
  private static Cached: Day[];

  constructor(private underlyingGymTimeSlotsRepository: IGymTimeSlotsRepository) { }

  public async createDefaultDoc(): Promise<void> {
    CachedGymTimeSlotsRepository.Cached = [];
    await this.underlyingGymTimeSlotsRepository.createDefaultDoc();
  }

  public async getAll(): Promise<Day[]> {
    if (!CachedGymTimeSlotsRepository.Cached || CachedGymTimeSlotsRepository.Cached.length === 0) {
      const gymTimeSlots = await this.underlyingGymTimeSlotsRepository.getAll();
      CachedGymTimeSlotsRepository.Cached = gymTimeSlots;
    }

    return CachedGymTimeSlotsRepository.Cached;
  }

  public async updateCache(): Promise<void> {
    CachedGymTimeSlotsRepository.Cached = await this.underlyingGymTimeSlotsRepository.getAll();
  }

  public async setOpenAllDayEveryDay(): Promise<void> {
    CachedGymTimeSlotsRepository.Cached = [];
    await this.underlyingGymTimeSlotsRepository.setOpenAllDayEveryDay();
  }
}
